import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../api';

export default function Timesheets() {
  const [timesheets, setTimesheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Get current user's timesheets only
    api('/me').then(r => r.ok ? r.json() : null).then(user => {
      if (user && user.userId) {
        // Find employee record for current user
        api('/hcm/employees?q=' + encodeURIComponent(user.userId)).then(r => r.ok ? r.json() : []).then(employees => {
          const userEmployee = employees.find(emp => emp.userId === user.userId);
          if (userEmployee) {
            // Get timesheets for this employee (mapped by HCM or self-mapped)
            api('/timesheets/timesheets?employeeId=' + userEmployee.id).then(r => r.ok ? r.json() : []).then(setTimesheets);
          } else {
            // No employee mapping found, redirect to self-mapping
            navigate('/self-map');
            return;
          }
          setLoading(false);
        }).catch(() => {
          // Error loading employees, redirect to self-mapping as fallback
          navigate('/self-map');
        });
      } else {
        setLoading(false);
      }
    }).catch(() => {
      setLoading(false);
    });
  }, [navigate]);

  const statusBadge = (status) => {
    const cls = status === 'APPROVED' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800';
    return <span className={`px-2 py-1 rounded-full text-xs font-medium ${cls}`}>{status}</span>;
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Timesheets</h2>
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Period</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Hours</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {timesheets.map(t => (
              <tr key={t.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-gray-600">
                  <Link to={`/timesheets/${t.id}`} className="text-amber-600 hover:text-amber-800 font-medium">{t.startDate} — {t.endDate}</Link>
                </td>
                <td className="px-6 py-4 text-gray-900 font-medium">{t.totalHours != null ? Number(t.totalHours).toFixed(2) : '—'}</td>
                <td className="px-6 py-4">{statusBadge(t.status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {timesheets.length === 0 && <div className="text-center py-12 text-gray-500">No timesheets found.</div>}
      </div>
    </Layout>
  );
}
